import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import React from "react";
import { forwardRefAs, Generic } from "../../base";
import { Checkbox } from "./checkbox";
import { Radio } from "./radio";
export var LABEL_DEFAULTS = {
  sizes: ["small", "medium", "large"]
};

var identifyLabelDiscriminator = function identifyLabelDiscriminator(children) {
  var discriminator = "label";
  React.Children.forEach(children, function (child, i) {
    if (typeof child === "object" && child !== null && "type" in child) {
      if (child.type === Checkbox || child.type === "input" && child.props.type === "checkbox") {
        discriminator = "checkbox";
      } else if (child.type === Radio || child.type === "input" && child.props.type === "radio") {
        discriminator = "radio";
      } else if (child.type === React.Fragment) {
        discriminator = identifyLabelDiscriminator(child.props.children);
      }
    }
  });
  return discriminator;
};

export var Label = forwardRefAs(function (_a, ref) {
  var _classNames;

  var className = _a.className,
      disabled = _a.disabled,
      size = _a.size,
      rest = tslib_1.__rest(_a, ["className", "disabled", "size"]);

  var discriminator = identifyLabelDiscriminator(rest.children);
  return React.createElement(Generic, Object.assign({
    className: classNames((_classNames = {}, _defineProperty(_classNames, "".concat(discriminator), discriminator), _defineProperty(_classNames, "is-disabled", disabled), _defineProperty(_classNames, "is-".concat(size), size), _classNames), className),
    ref: ref
  }, rest));
}, {
  as: "label"
});
Label.displayName = "Label";